"use client";

import React, { useEffect, useState } from "react";
import { useSession } from "next-auth/react";
import Link from "next/link";

const AnnouncementBar = () => {
  const { data: session, status } = useSession();
  const [subscriptionFlow, setSubscriptionFlow] = useState(null);
  const [loading, setLoading] = useState(status === "loading");

  const SHOW_FLOWS = [
    "free_active",
    "free_expired",
    "unlimited_expired",
    "institutional_expired",
  ];

  useEffect(() => {
    if (status === "authenticated") {
      fetch(`${process.env.NEXT_PUBLIC_API_URL}/user/get-subscription`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${session.token}`,
        },
      })
        .then((res) => {
          if (!res.ok) throw new Error("Error fetching subscription");
          return res.json();
        })
        .then((data) => setSubscriptionFlow(data.subscription_flow_status))
        .catch(() => setSubscriptionFlow(null))
        .finally(() => setLoading(false));
    } else if (status === "unauthenticated") {
      setLoading(false);
    }
  }, [status, session]);

  if (loading) return null;

  if (status === "authenticated" && !SHOW_FLOWS.includes(subscriptionFlow)) {
    return null;
  }

  let pillText = "Empieza gratis";
  let message =
    "Crea tus primeras clases con 20 Bits del Saber gratis cada mes en TutorIA+.";
  let href = "/registrarse";
  let buttonText = "Crear mi clase";

  if (status === "authenticated" && SHOW_FLOWS.includes(subscriptionFlow)) {
    pillText = "Plan Ilimitado";
    message =
      "Crea todas tus clases sin límites. Pásate al Plan Ilimitado por solo $ 4.99 al mes.";
    href = "/planes";
    buttonText = "Ver planes";
  }

  return (
    <div className="header-top-news bg-image1">
      <div className="wrapper">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="inner">
                <div className="content">
                  <span className="rainbow-badge">{pillText}</span>
                  <span className="news-text">{message}</span>
                </div>
                <div className="right-button">
                  <Link className="btn-read-more" href={href}>
                    <span>
                      {buttonText}{" "}
                      <i className="fa-sharp fa-regular fa-arrow-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBar;
